import { render } from "./LeftTopLogo.vue?vue&type=template&id=fdd2ccea&scoped=true"
import script from "./LeftTopLogo.vue?vue&type=script&lang=js"
export * from "./LeftTopLogo.vue?vue&type=script&lang=js"

import "./LeftTopLogo.vue?vue&type=style&index=0&id=fdd2ccea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdd2ccea"]])

export default __exports__